export default {
  "zh-CN": {
    title: "听书",
    eyebrow: "STARLIVE 听书",
    available: "本章支持听书",
    unavailable: "本章暂无听书音频",
    play: "播放听书",
    pause: "暂停听书",
    previous: "上一章听书",
    next: "下一章听书",
    speed: "播放倍速",
    progress: "听书进度",
    close: "关闭听书面板",
    loadFailed: "听书音频加载失败，请稍后重试"
  },
  "en-US": {
    title: "Audiobook",
    eyebrow: "STARLIVE AUDIOBOOK",
    available: "Audiobook available for this chapter",
    unavailable: "No audiobook audio for this chapter",
    play: "Play audiobook",
    pause: "Pause audiobook",
    previous: "Previous chapter audio",
    next: "Next chapter audio",
    speed: "Playback speed",
    progress: "Audiobook progress",
    close: "Close audiobook panel",
    loadFailed: "The audiobook audio could not be loaded. Try again later."
  },
  "ar-SA": {
    title: "الكتاب الصوتي",
    eyebrow: "كتاب STARLIVE الصوتي",
    available: "يتوفر صوت لهذا الفصل",
    unavailable: "لا يتوفر صوت لهذا الفصل",
    play: "تشغيل الكتاب الصوتي",
    pause: "إيقاف مؤقت",
    previous: "صوت الفصل السابق",
    next: "صوت الفصل التالي",
    speed: "سرعة التشغيل",
    progress: "تقدم الاستماع",
    close: "إغلاق لوحة الكتاب الصوتي",
    loadFailed: "تعذر تحميل صوت الكتاب. حاول لاحقًا."
  }
}
